import type { IContentItem } from '@kontent-ai/delivery-sdk';
import { useScreenDetector } from '../../hooks';
import { config } from '@r-and-a-shared-ui/core-component-config';
import { RenderOn } from '../RenderOn/RenderOn';
import { ImageProps } from '../Image/Image';
import BurgerTOCComponent from '../BurgerTOCComponent/BurgerTOCComponent';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';
import { useEffect, useState } from 'react';
import { api } from '@r-and-a-shared-ui/randa-trpc-client';
import { hasValue } from '@r-and-a-shared-ui/utils';
import { MEMBERSHIP_MODELS } from '@r-and-a-shared-ui/common-kontent-client';
import { MenuFooterProps } from '../MenuFooter/MenuFooter';

export const HeaderMainMenu = ({
  menuEntry,
}: {
  menuEntry: IContentItem<any>;
}) => {
  const { isMobile } = useScreenDetector();
  const Menu = config.menu.component();
  const menuProps = config.menu.mapEntryToProps(menuEntry);
  if (!menuEntry || !Menu || !menuProps) {
    return null;
  }
  const rawImage = menuEntry.elements?.background_image?.value?.[0];
  let adaptedImage: ImageProps | undefined;
  if (rawImage) {
    adaptedImage = {
      imageUrl: rawImage.url,
      license: 'default-license',
      width: rawImage?.width || 100,
      height: rawImage?.height || 100,
      alt: rawImage.name,
    };
  }
  const [loadedFooter, setLoadedFooter] = useState(
    menuEntry.elements?.footer?.linkedItems?.[0],
  );
  const [isDataFetched, setIsDataFetched] = useState<boolean>(true);

  const { data: footerData } = api.kontent.itemWithLinkedItems.useQuery({
    codename: isDataFetched ? '' : loadedFooter?.system?.codename ?? '',
    depthParameter: 3,
  });

  if (hasValue(footerData)) {
    setLoadedFooter(footerData);
    setIsDataFetched(true);
  }

  useEffect(() => {
    const logos = loadedFooter?.elements?.logos;
    if (logos?.linkedItems?.length === logos?.value?.length) {
      return;
    }
    setIsDataFetched(false);
  }, [loadedFooter]);

  const footerElements = kontentAiDataMapping.menu_footer(
    loadedFooter as MEMBERSHIP_MODELS.MenuFooter,
  )?.logos as MenuFooterProps[] | undefined;

  return (
    <Menu
      key={menuEntry.system.id}
      {...menuProps}
      menuStyle={'main_menu'}
      backgroundImage={adaptedImage}
      footer={footerElements}
      extraItems={[
        <RenderOn condition={isMobile} key={'burger-toc'}>
          <BurgerTOCComponent/>
        </RenderOn>
      ].filter(Boolean)}
    />
  );
};
